<div mat-dialog-title style="display:flex;align-items:center;justify-content:space-between">
  <span>Buscar descuadres</span>
  <button mat-icon-button (click)="close()" aria-label="Cerrar" style="flex-shrink:0">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content style="padding:16px 24px;min-width:300px">

  <mat-form-field appearance="outline" style="width:100%">
    <mat-label>Fecha inicio</mat-label>
    <input matInput [matDatepicker]="date" weekStart=1 [formControl]="fromDate" required>
    <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
    <mat-datepicker #date></mat-datepicker>
  </mat-form-field>

  <p class="mat-body-2" style="color:#dc2626;margin:8px 0 0" *ngIf="error">
    Ha ocurrido un error al descargar el documento.
  </p>

</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="close()">Cancelar</button>
  <button mat-flat-button color="primary" (click)="downloadAccountingImbalence()">
    <mat-icon>file_download</mat-icon>
    Descargar
  </button>
</mat-dialog-actions>
